export default "__VITE_ASSET__D6R1DoPf__"